/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The current status of the agreement.
 * @export
 * @enum {string}
 */
export enum AgreementRecordStatus {
  Draft = 'draft',
  Sent = 'sent',
  Signed = 'signed',
  Cancelled = 'cancelled',
  Complete = 'complete',
  Expired = 'expired',
  BackgroundCheck = 'backgroundCheck',
  SafetyTraining = 'safetyTraining',
  AdobeSign = 'adobeSign',
  AwaitingConfirmation = 'awaitingConfirmation',
}

export function AgreementRecordStatusFromJSON(
  json: any
): AgreementRecordStatus {
  return AgreementRecordStatusFromJSONTyped(json, false)
}

export function AgreementRecordStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgreementRecordStatus {
  return json as AgreementRecordStatus
}

export function AgreementRecordStatusToJSON(
  value?: AgreementRecordStatus | null
): any {
  return value as any
}
